import { Icon } from "semantic-ui-react";

import { ScrollColumn } from "components/BaseTableV3/ScrollColumn";
import revOppsConstants from "constants/RevenueOpportunity";
import { RecipientsTableActions } from "./RecipientsTableActions";
import { upperFirst } from "lodash";

export const getRecipientsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Type",
      id: "Type",
      accessorKey: "types",
      cell: ({ row }) => {
        const value = row.original?.types;
        if (value !== undefined && value !== null) {
          return (
            <ScrollColumn>
              {value.sort().map(type => (
                <li key={type}>{upperFirst(type)}</li>
              ))}
            </ScrollColumn>
          );
        }
        return "";
      },
    },
    {
      header: "Enabled",
      id: "Enabled",
      accessorKey: "enabled",
      cell: ({ row }) => (
        <Icon
          name={row.original?.enabled ? "check" : "close"}
          color={row.original?.enabled ? "green" : "red"}
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <RecipientsTableActions original={row.original} />,
    },
  ];
};

export const getRecipientsTableFilters = () => [
  {
    key: "types",
    title: "Type",
    type: "select",
    data: Object.values(revOppsConstants.recipientType).map(type => ({
      id: type,
      name: upperFirst(type),
    })),
  },
  {
    key: "enabled",
    title: "Status",
    type: "select",
    data: [
      { id: true, name: "Enabled" },
      { id: false, name: "Disabled" },
    ],
  },
];
